import React from 'react'
import Wix from 'Wix';
import { connect } from 'react-redux'
import { ImageContainer } from './style'
import { convertStyle, getDiffToMobileConvert, convertMobileUmitableFields } from '../../../../../editSlide/api/converter'
import { getBackgroundGradient } from '../../../../../Utils/utils';
import { getRightPropertyValue } from '../../../../../Utils/helpers';
import { calculateAbsoluteFromCenterPoint, getImageDimensions } from '../../../../../editSlide/modules/MainView/Workspace/Captions/ImageCaption';

class ImageCaption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            shapeStyle: {
                backgroundColor: null,
                height: null,
                position: null,
                width: null,
            },
        }
    }


    componentWillMount() {
        //     const deviceType = Wix.Utils.getDeviceType()
        //     this.setState({
        //         shapeStyle: this.getShapeStyle(this.props.caption, deviceType)
        //     })
    }

    componentWillReceiveProps(newProps) {
        // const deviceType = Wix.Utils.getDeviceType()
        // this.setState({
        //     shapeStyle: this.getShapeStyle(newProps.caption, deviceType)
        // })
    }

    goToLink() {
        if (this.props.caption.onClick && this.props.caption.onClick.value === 'doNothing') return
        // сначала проверяем, есть ли ссылка из новых настроек
        if (this.props.caption.linkTo) {
            Wix.navigateTo(this.props.caption.linkTo, () => { })
        }
        // если нет новой, то используем старую
        else if (this.props.caption.onClick.value === 'navigateTo') {
            switch (this.props.caption.linkType.value) {
                case 'link':
                    window.open(this.props.caption.link, '_blank');
                    break;
                case 'wix':
                    Wix.navigateTo({
                        'type': 'PageLink',
                        'pageId': this.props.caption.link.value
                    }, () => { });
                    break;
                case 'anchor':
                    Wix.navigateToAnchor(this.props.caption.link.value, function (error) { console.log(error.error) });
                    break;
            }
        }
    }

    getShapeStyle(caption, viewType) {
        const isMobile = viewType === 'mobile'
        const desktopDims = this.props.slide === undefined ? { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight } : { width: this.props.slide.editedWidth, height: this.props.slide.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        if (viewType === 'mobile') {
            const { mobileDiffW, mobileDiffH } = getDiffToMobileConvert(
                this.props.widgetDimensions.width,
                this.props.widgetDimensions.height,
                this.props.widgetDimensions.mobileWidth,
                this.props.widgetDimensions.mobileHeight,
            )
            const maxDiff = mobileDiffW > mobileDiffH ? mobileDiffW : mobileDiffH
            caption = convertMobileUmitableFields(_.cloneDeep(caption), mobileDiffW, mobileDiffH, maxDiff)
        }
        let borderRadiusProperty, borderWidthProperty, widthProperty, positionProperty, heightProperty, paddingProperty;

        switch (viewType) {
            case 'desktop':
                borderRadiusProperty = 'borderRadius';
                borderWidthProperty = 'borderWidth';
                widthProperty = 'width';
                heightProperty = 'height';
                positionProperty = 'position';
                paddingProperty = 'padding';
                break;

            case 'mobile':
                borderRadiusProperty = 'mobileBorderRadius';
                borderWidthProperty = 'mobileBorderWidth';
                widthProperty = 'mobileWidth';
                heightProperty = 'mobileHeight';
                positionProperty = 'mobilePosition';
                paddingProperty = 'mobilePadding';
                break;
        }

        

        // const captionStyle = {
        //     backgroundColor: caption.backgroundColor,
        //     overlayColor: caption.overlayColor,
        //     borderColor: caption.borderColor,
        //     borderRadius: caption[borderRadiusProperty],
        //     borderWidth: caption[borderWidthProperty],
        //     height: caption[heightProperty],
        //     padding: caption[paddingProperty],
        //     shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.size}px ${caption.shadow.color}`,
        //     position: {
        //         x: caption.boxId === '' ? caption[positionProperty].x : caption[positionProperty].relativeX,
        //         y: caption.boxId === '' ? caption[positionProperty].y : caption[positionProperty].relativeY
        //     },
        //     width: caption[widthProperty],
        //     zIndex: caption.layer + 200,
        // }
        let captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, caption)
        if (caption.boxId !== '' && isMobile && caption.mobilePosition && caption.mobilePosition.relativeX == undefined) {
            const clonedCaption = _.cloneDeep(caption)
            delete clonedCaption.mobilePosition
            const convertedPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, clonedCaption)
            captionPosition = {
                ...captionPosition,
                relativeX: convertedPosition.relativeX,
                relativeY: convertedPosition.relativeY
            }
        }
        const xProp = caption.boxId === '' ? 'x' : 'relativeX'
        const yProp = caption.boxId === '' ? 'y' : 'relativeY'

        const captionStyle = {
            backgroundColor: caption.backgroundColor,
            overlayColor: caption.overlayColor,
            borderColor: caption.borderColor,
            borderRadius: getRightPropertyValue(desktopDims, mobileDims, 'borderRadius', isMobile, caption),
            borderWidth: getRightPropertyValue(desktopDims, mobileDims, 'borderWidth', isMobile, caption),
            width: getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, caption),
            height: getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, caption),
            padding: getRightPropertyValue(desktopDims, mobileDims, 'padding', isMobile, caption),
            shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.size}px ${caption.shadow.color}`,
            position: {
                x: captionPosition[xProp],
                y: captionPosition[yProp]
            },
            zIndex: caption.layer + 200,
        }


        // в мобильной версии капча уезжала наверх, видимо не учитывалась конвертация
        // if (captionStyle.position.x > this.props.settingsReducer.widgetDimensions[widthProperty]) {
        //     captionStyle.position.x = 0
        // }

        // if (captionStyle.position.y > this.props.settingsReducer.widgetDimensions[heightProperty]) {
        //     captionStyle.position.y = 0
        // }

        return captionStyle
    }

    getImageSrc(caption) {
        
    }


    render() {
        const caption = this.props.caption
        const deviceType = Wix.Utils.getDeviceType()
        const isMobile = deviceType === 'mobile'
        const hasCustomShape = caption.shape != 'rectangle' && caption.shape != undefined

        const shapeStyle = this.getShapeStyle(this.props.caption, deviceType)
        const unicalClassName = this.props.unicalClassName ? `caption-${this.props.slideIndex}-${this.props.captionIndex}-${this.props.unicalClassName} ` : ''
        const shapeContainerStyles = {
            left: shapeStyle.position.x,
            top: shapeStyle.position.y,
            zIndex: shapeStyle.zIndex,
            cursor: caption.linkTo || caption.onClick && caption.onClick.value === 'navigateTo' ? 'pointer' : 'default',
        }
        const innerShapeStyles = {
            width: shapeStyle.width,
            height: shapeStyle.height,
            background: getBackgroundGradient({ backgroundColor: shapeStyle.backgroundColor }),
            overlayColor: getBackgroundGradient({ backgroundColor: shapeStyle.overlayColor }),
            borderColor: shapeStyle.borderColor,
            borderRadius: shapeStyle.borderRadius,
            boxShadow: shapeStyle.shadow,
            borderWidth: shapeStyle.borderWidth,
        }



        const borderRadius = shapeStyle.borderRadius
        const borderWidth = shapeStyle.borderWidth
        const borderColor = shapeStyle.borderColor

        let svgShadow = ''

        if (caption.hasShadow) {
            svgShadow = `drop-shadow(${getRightPropertyValue({}, {}, 'x', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue({}, {}, 'y', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue({}, {}, 'blur', isMobile, caption.shadow)}px `
                + `${caption.shadow.color})`
        }
        const defaultSize = { width: shapeStyle.width, height: shapeStyle.height }
        defaultSize.width -= shapeStyle.padding * 2
        defaultSize.height -= shapeStyle.padding * 2
        defaultSize.width -= shapeStyle.borderWidth * 2
        defaultSize.height -= shapeStyle.borderWidth * 2

        const imgDims = getImageDimensions(defaultSize, caption.originalDimensions)

        const imageCrop = getRightPropertyValue({}, {}, 'crop', isMobile, caption)

        let imageScale = imageCrop.scale

        const imageCropAbsolute = calculateAbsoluteFromCenterPoint(imageCrop.centerPoint, defaultSize, imgDims, imageScale)

        const flipStyle = caption.flip ? `scaleX(${caption.flip.x ? -1 : 1}) scaleY(${caption.flip.y ? -1 : 1})` : ''
        const widthRatio = defaultSize.width * (imageScale / 100) / caption.originalDimensions.width
        let heightFromWidth = caption.originalDimensions.height * widthRatio
        let ratioExceed = 1
        if (heightFromWidth < defaultSize.height) {
            const newHeightForRatio = Math.max(250, defaultSize.height)
            ratioExceed = newHeightForRatio / heightFromWidth
            heightFromWidth = newHeightForRatio
        }
        const imgSrc = Wix.Utils.Media.getResizedImageUrl(caption.relativeUri, defaultSize.width * (imageScale / 100) * ratioExceed, heightFromWidth)
        return (
            <ImageContainer
                id={`caption-${this.props.caption.index}`}
                onClick={e => this.goToLink()}
                {...innerShapeStyles}
                style={{ ...shapeContainerStyles, ...innerShapeStyles, position: 'absolute', boxShadow: 'none' }}
                className={`caption-container-${this.props.slideIndex}-${this.props.captionIndex} animated animate-${this.props.slideIndex}-${this.props.captionIndex} caption-${this.props.slideIndex}-${this.props.captionIndex} caption-content ${unicalClassName}`}
                // position={shapeStyle.position}
                // zIndex={shapeStyle.zIndex}
                // position={this.state.shapeStyle.position}
                data-animation-in={this.props.animationIn || 'null'}
            >
                <div
                    className='bg-img-container'
                    style={{
                        width: '100%',
                        height: '100%',
                        background: innerShapeStyles.background,
                        padding: shapeStyle.padding,
                    }}
                >
                    <div
                        className='bg-img-border'
                        style={{
                            width: '100%',
                            height: '100%',
                            boxShadow: innerShapeStyles.boxShadow,
                        }}
                    >
                        <img
                            src={imgSrc}
                            style={{
                                display: 'block',
                                position: 'absolute',
                                width: imgDims.width * (imageScale / 100),
                                height: imgDims.height * (imageScale / 100),
                                maxHeight: 'initial',
                                maxWidth: 'initial',
                                transform: `translate(${imageCropAbsolute.transformX}px, ${imageCropAbsolute.transformY}px) ${flipStyle}`
                            }}
                        />
                        <div className='overlay' />
                    </div>

                </div>

            </ImageContainer>
        )
    }
}


// function mapStateToProps(state) {
//     return state
// }

// export default connect(mapStateToProps)(ImageCaption)
export default ImageCaption